import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { ViewportSliceDTO } from './types'

export const VIEWPORT_FRAGMENT: TypedDocumentNode<ViewportSliceDTO> = gql`
  fragment ViewportFragment on Viewport {
    bannerEnabled
    bannerSizes
    id
    minimumWidth
    name
    nativeEnabled
    videoEnabled
    playerSize
    updatedAt
  }
`
